import axiosInstance from "../../../helpers/axiosInstance";

export const updatePassword = (payload) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post("backoffice/LoginBackoffice/update-password", payload)
      .then((res) => {
        if (res.data.status !== "Error") {
          resolve(res.data);
        } else {
          reject(res.data.errors);
        }
      })
      .catch((err) => {
        reject(
          err.response
            ? err.response.data
            : "NO SE PUEDE REALIZAR ESTA ACCIÓN. INTÉNTELO MÁS TARDE"
        );
      });
  });
};